module.exports = __webpack_public_path__ + "img/Vector.6c30920c.svg";